import Gui from './manager/gui'
import LayersManager from './manager/layers'
import State from './manager/state'

interface App {
  gui: Gui | null
  layersManager: LayersManager | null
  state: State | null
}

const app: App = {
  gui: null,
  layersManager: null,
  state: null,
}

export default app
